import {
  DialogTitle,
  DialogContent,
  Box,
  TextField,
  DialogActions,
  Button,
} from '@mui/material'

const ReferrerDetails = ({
  referrerName,
  referrerMobile,
  setReferrerName,
  setReferrerMobile,
  onClose,
  onSubmitReferrer,
}: {
  referrerName: string
  referrerMobile: string
  setReferrerName: (e: string) => void
  setReferrerMobile: (e: string) => void
  onClose: any
  onSubmitReferrer: any
}) => {
  return (
    <>
      <DialogTitle>Edit Referrer Information</DialogTitle>
      <DialogContent>
        <Box display={'flex'} flexDirection={'column'} gap={2} mt={2}>
          <TextField
            label='Referrer Name'
            value={referrerName}
            onChange={(e) => setReferrerName(e.target.value)}
            fullWidth
            variant='outlined'
            size='small'
          />
          <TextField
            label='Referrer Mobile'
            value={referrerMobile}
            onChange={(e) => setReferrerMobile(e.target.value)}
            fullWidth
            variant='outlined'
            size='small'
          />
        </Box>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} color='primary'>
          Cancel
        </Button>
        <Button
          onClick={onSubmitReferrer}
          color='primary'
          variant='contained'
          disabled={!referrerName.trim()}
        >
          Submit
        </Button>
      </DialogActions>
    </>
  )
}
export default ReferrerDetails
